module.exports = __webpack_public_path__ + "static/media/pep_square.f2c70667.png";